import { SxProps, Theme } from "@mui/material";

const getStyles = (theme: Theme): Record<string, SxProps<Theme>> => ({
  container: {
    flexDirection: "column",
    gap: "var(--rhythm)",
    p: "calc(2 * var(--rhythm))",
    [theme.breakpoints.down("md")]: {
      gap: 0,
      p: "var(--rhythm)",
    },
  },

  scrollable: {
    [theme.breakpoints.down("md")]: {
      height: "auto",
      overflowY: "auto",
    },
    "@media screen and (min-height:1270px)": {
      height: "calc(100vh - calc(38.5 * var(--rhythm)))",
      overflowY: "scroll",
    },
  },

  families: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    gap: "calc(1 * var(--rhythm))",
  },
});

export default getStyles;
